import { usePaginationQueryParams } from '@/shared/components/ui/pagination/hooks/use-pagination-query-params/use-pagination-query-params';
import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { IFilterBuilder } from '@/shared/filters/filter-builder.interfaces';
import { useDirectFilter } from '@/shared/filters/hooks/use-direct-filter/use-direct-filter';
import { TFilterConfig } from '@/shared/filters/hooks/use-direct-filter/use-direct-filter.types';
import { PaginationInput } from '@/shared/types/types.generated';

export const useGroupedResourceQueryParams = <T>(
  groupId?: string,
  filterBuilder?: IFilterBuilder<T>,
) => {
  const { page, pageSize } = usePaginationQueryParams();
  const pagination: PaginationInput = { page, pageSize };

  const isUngrouped = groupId === UNGROUPED_RESOURCES_GROUP_ID;

  const filters: Partial<Record<keyof T, string | string[] | TFilterConfig>> =
    {};

  if (groupId !== undefined && !isUngrouped) {
    (filters as any).groupId = groupId;
  }

  if (isUngrouped) {
    (filters as any).groupId = { value: 'eq', method: 'doNotIgnoreNullable' };
  }

  const filter = useDirectFilter<T>(filterBuilder, filters);

  return {
    filter,
    pagination,
    isUngrouped,
  };
};
